/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetLinkInput } from './WidgetLinkInput';
import {
    WidgetLinkInputFromJSON,
    WidgetLinkInputFromJSONTyped,
    WidgetLinkInputToJSON,
    WidgetLinkInputToJSONTyped,
} from './WidgetLinkInput';
import type { WidgetDocumentInput } from './WidgetDocumentInput';
import {
    WidgetDocumentInputFromJSON,
    WidgetDocumentInputFromJSONTyped,
    WidgetDocumentInputToJSON,
    WidgetDocumentInputToJSONTyped,
} from './WidgetDocumentInput';

/**
 * 
 * @export
 * @interface WidgetSubmitRequest
 */
export interface WidgetSubmitRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    homeownerName: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    homeownerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    homeownerPhone: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    homeownerPhone2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    homeownerEmail2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    propertyAddress: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    mailingAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    dateOfLoss?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    causeOfLoss?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    insuranceCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    contractor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    contractorContact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    contractorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    contractorPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    idempotencyKey?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    captchaToken?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    parentOrigin?: string;
    /**
     * Honeypot field, should remain empty
     * @type {string}
     * @memberof WidgetSubmitRequest
     */
    companyWebsite?: string;
    /**
     * 
     * @type {Array<WidgetLinkInput>}
     * @memberof WidgetSubmitRequest
     */
    links?: Array<WidgetLinkInput>;
    /**
     * 
     * @type {Array<WidgetDocumentInput>}
     * @memberof WidgetSubmitRequest
     */
    documents?: Array<WidgetDocumentInput>;
}

/**
 * Check if a given object implements the WidgetSubmitRequest interface.
 */
export function instanceOfWidgetSubmitRequest(value: object): value is WidgetSubmitRequest {
    if (!('homeownerName' in value) || value['homeownerName'] === undefined) return false;
    if (!('homeownerEmail' in value) || value['homeownerEmail'] === undefined) return false;
    if (!('homeownerPhone' in value) || value['homeownerPhone'] === undefined) return false;
    if (!('propertyAddress' in value) || value['propertyAddress'] === undefined) return false;
    return true;
}

export function WidgetSubmitRequestFromJSON(json: any): WidgetSubmitRequest {
    return WidgetSubmitRequestFromJSONTyped(json, false);
}

export function WidgetSubmitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetSubmitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'homeownerName': json['homeownerName'],
        'homeownerEmail': json['homeownerEmail'],
        'homeownerPhone': json['homeownerPhone'],
        'homeownerPhone2': json['homeownerPhone2'] == null ? undefined : json['homeownerPhone2'],
        'homeownerEmail2': json['homeownerEmail2'] == null ? undefined : json['homeownerEmail2'],
        'propertyAddress': json['propertyAddress'],
        'mailingAddress': json['mailingAddress'] == null ? undefined : json['mailingAddress'],
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : json['dateOfLoss'],
        'causeOfLoss': json['causeOfLoss'] == null ? undefined : json['causeOfLoss'],
        'insuranceCompany': json['insuranceCompany'] == null ? undefined : json['insuranceCompany'],
        'contractor': json['contractor'] == null ? undefined : json['contractor'],
        'contractorContact': json['contractorContact'] == null ? undefined : json['contractorContact'],
        'contractorEmail': json['contractorEmail'] == null ? undefined : json['contractorEmail'],
        'contractorPhone': json['contractorPhone'] == null ? undefined : json['contractorPhone'],
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'description': json['description'] == null ? undefined : json['description'],
        'idempotencyKey': json['idempotencyKey'] == null ? undefined : json['idempotencyKey'],
        'captchaToken': json['captchaToken'] == null ? undefined : json['captchaToken'],
        'parentOrigin': json['parentOrigin'] == null ? undefined : json['parentOrigin'],
        'companyWebsite': json['companyWebsite'] == null ? undefined : json['companyWebsite'],
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(WidgetLinkInputFromJSON)),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(WidgetDocumentInputFromJSON)),
    };
}

export function WidgetSubmitRequestToJSON(json: any): WidgetSubmitRequest {
    return WidgetSubmitRequestToJSONTyped(json, false);
}

export function WidgetSubmitRequestToJSONTyped(value?: WidgetSubmitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'homeownerName': value['homeownerName'],
        'homeownerEmail': value['homeownerEmail'],
        'homeownerPhone': value['homeownerPhone'],
        'homeownerPhone2': value['homeownerPhone2'],
        'homeownerEmail2': value['homeownerEmail2'],
        'propertyAddress': value['propertyAddress'],
        'mailingAddress': value['mailingAddress'],
        'dateOfLoss': value['dateOfLoss'],
        'causeOfLoss': value['causeOfLoss'],
        'insuranceCompany': value['insuranceCompany'],
        'contractor': value['contractor'],
        'contractorContact': value['contractorContact'],
        'contractorEmail': value['contractorEmail'],
        'contractorPhone': value['contractorPhone'],
        'policyNumber': value['policyNumber'],
        'description': value['description'],
        'idempotencyKey': value['idempotencyKey'],
        'captchaToken': value['captchaToken'],
        'parentOrigin': value['parentOrigin'],
        'companyWebsite': value['companyWebsite'],
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(WidgetLinkInputToJSON)),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(WidgetDocumentInputToJSON)),
    };
}

